export function formatMoney(amount) {
  if (!amount || isNaN(amount)) {
    return '$0.00';
  }
  return `${'$'}${amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`;
}

export function formatCommas(amount) {
  return `${amount.toLocaleString('en-US')}`;
}

export function npnIsValid(NPN) {
  return (
    NPN !== null &&
    NPN !== 0 &&
    NPN !== '' &&
    NPN !== '0' &&
    NPN !== 1 &&
    NPN !== '1' &&
    NPN.toString().length > 4 &&
    NPN.toString().length <= 9
  );
}
